export const UNDEFINED_MEDIA_LIBRARY_BASE_URL = new Error(
  'Please provide value for Media Library base API url in TisaMediaLibraryModule.forRoot() method.',
);
